import { isTabletPortraitDown } from '@enter/core';
import { mdiArrowLeft } from '@mdi/js';
import { Icon } from '@mdi/react';
import { ContactSupport } from 'components';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { ISettingsPage } from '../shared';
import * as S from '../shared.styles';

export const Phone: React.FunctionComponent = inject('rootStore')(
    observer(
        (props: ISettingsPage): React.ReactElement => {
            const phone = _.get(props, 'rootStore.userPhone', '');
            return (
                <S.SubCategoryItem>
                    {isTabletPortraitDown() && (
                        <S.ReturnLink to="/settings/overview">
                            {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                        </S.ReturnLink>
                    )}
                    <S.SubCategoryH1>What is your phone number?</S.SubCategoryH1>
                    <S.InputGroup>
                        <S.Label>Phone</S.Label>
                        <S.Input value={phone} disabled={true} />
                    </S.InputGroup>
                    <ContactSupport action="change your phone number" subject="Need help changing phone number" />
                </S.SubCategoryItem>
            );
        },
    ),
);
